"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCenterAbsolutely = exports.centerHorizontally = exports.centerVertically = exports.centerAbsolutely = void 0; // .......... CENTERING .......... //
// center element absolutely

var centerAbsolutely = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};
exports.centerAbsolutely = centerAbsolutely;
var centerVertically = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
exports.centerVertically = centerVertically;
var centerHorizontally = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)'
};
exports.centerHorizontally = centerHorizontally;
var removeCenterAbsolutely = {
  position: 'relative',
  top: '0',
  left: '0',
  transform: 'none'
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.removeCenterAbsolutely = removeCenterAbsolutely;